import { createAction, props } from '@ngrx/store';
import { CtdOrder } from '../reducers/ctd-order.reducer';

export const resetCtdOrder = createAction('[CTD] Reset State');

export const initCtdOrder = createAction('[CTD/ORDER] Init Entity', props<{ id: string }>());
export const resetCtdOrderState = createAction('[CTD/ORDER] Reset Entity', props<{ id: string }>());

// CtdOrder Detail
export const fetchCtdOrder = createAction('[CTD/ORDER] Fetch Entity start', props<{ id: string }>());
export const fetchCompletedCtdOrder = createAction(
  '[CTD/ORDER] Fetch Entity completed',
  props<{ payload: Partial<CtdOrder> }>(),
);
export const updateCtdOrder = createAction(
  '[CTD/ORDER] Update Entity',
  props<{ payload: Partial<CtdOrder> }>(),
);
export const selectCtdOrder = createAction(
  '[CTD/ORDER] Select Entity',
  props<{ id: string }>(),
);
export const fetchCanceledCtdOrder = createAction('[CTD/ORDER] Fetch Entity canceled', props<{ id: string }>());

// CtdOrder Confirmed
export const fetchCtdOrderConfirmed = createAction(
  '[CTD/ORDER] Fetch Entity Dispatches Confirmed start',
  props<{ id: string }>(),
);
export const fetchCompletedCtdOrderConfirmed = createAction(
  '[CTD/ORDER] Fetch Entity Dispatches Confirmed completed',
  props<{ id: string }>(),
);
export const fetchCanceledCtdOrderConfirmed = createAction(
  '[CTD/ORDER] Fetch Entity Dispatches Confirmed canceled',
  props<{ id: string }>(),
);

// CtdOrder Released
export const fetchCtdOrderReleased = createAction(
  '[CTD/ORDER] Fetch Entity Dispatches Released start',
  props<{ id: string }>(),
);
export const fetchCompletedCtdOrderReleased = createAction(
  '[CTD/ORDER] Fetch Entity Dispatches Released completed',
  props<{ id: string }>(),
);
export const fetchCanceledCtdOrderReleased = createAction(
  '[CTD/ORDER] Fetch Entity Dispatches Released canceled',
  props<{ id: string }>(),
);

export const CtdOrderActions = {
  initCtdOrder,
  resetCtdOrder,
  resetCtdOrderState,

  updateCtdOrder,
  selectCtdOrder,

  fetchCtdOrder,
  fetchCompletedCtdOrder,
  fetchCanceledCtdOrder,

  fetchCtdOrderConfirmed,
  fetchCompletedCtdOrderConfirmed,
  fetchCanceledCtdOrderConfirmed,

  fetchCtdOrderReleased,
  fetchCompletedCtdOrderReleased,
  fetchCanceledCtdOrderReleased,
};

export default CtdOrderActions;
